import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { animateScroll } from "react-scroll";
import { useMediaQuery } from "react-responsive";
import { notifyError } from "../../../../helpers/helpers";

const initialValues = {
  accountNo: "1654518426155",
  re_accountNo: "1654518426155",
  bankName: "Indian Bank",
  ifsc: "IND8936FD",
  branch: "Coimbatore",
  holderName: "Manoj",
  chequeFile: "cheque.pdf",
};

function WalletUpdateBank() {
 const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("cheque.pdf");
  const isTablet = useMediaQuery({ query: "(max-width: 700px)" });

  useEffect(() => {
    const pasteBox = document.getElementById("no-paste");
    pasteBox.onpaste = (e) => {
      e.preventDefault();
      return false;
    };
  }, []);

  const handleFileChange = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (file) {
      if (
        file.type === "application/pdf" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg"
      ) {
        setFileName(file?.name);
        setFieldValue("chequeFile", file);
      } else {
        setFileName("");
        setFieldValue("chequeFile", "");
        notifyError(
          "Unsupported file format. Only JPG, JPEG, and PDF files are allowed."
        );
      }
    } else {
      setFileName("");
      setFieldValue("chequeFile", "");
    }
  };

  const handleSpanClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    animateScroll.scrollToTop({ smooth: true });
  });
  return (
    <div className="mt-1 ">
      <div className="valign-wrapper space-between">
        <h3 className="margin-0px">Update Bank Account</h3>
        <span className="material-icons-outlined pointer modal-close">
          close
        </span>
      </div>
      <div>
        <div
          className={` flex justify-center mt-1`}
          style={{ padding: "1rem 1rem 1rem 0rem" }}
        >
          <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape({
              accountNo: Yup.string()
                .min(11, "Account Number must be at least 11 characters")
                .max(15, "Account Number must be less than 15 characters")
                .required("Account Number is required")
                .matches(/^\S*$/, "Account Number cannot contain spaces"),
              re_accountNo: Yup.string()
                .oneOf(
                  [Yup.ref("accountNo"), null],
                  "Account Number  should be same."
                )
                .required("Confirm Account Number is required"),
              ifsc: Yup.string()
                .required("IFSC Code is required")
                .matches(/^\S*$/, "IFSC Code cannot contain spaces"),
              bankName: Yup.string()
                .required("Bank Name is required")
                .matches(/^\S.*$/, "Bank Name cannot contain spaces"),
              branch: Yup.string()
                .required("Branch Name is required")
                .matches(/^\S.*$/, "Branch Name cannot contain spaces"),
              holderName: Yup.string()
                .required("Account Holder Name is required")
                .matches(/^\S.*$/, "Account Holder Name cannot contain spaces"),
              chequeFile: Yup.string().required("Cheque File is required"),
            })}
            onSubmit={(values, { setSubmitting }) => {}}
          >
            {({ setFieldValue, isSubmitting, errors, touched }) => (
              <Form>
                <div className="valign-wrapper column gap-1 p-1">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: isTablet
                        ? "repeat(1,1fr)"
                        : "repeat(2,1fr)",
                      columnGap: "40px",
                    }}
                  >
                    <span>
                      <label className="font-16px black-text">
                        Account Number <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style"
                        type="number"
                        name="accountNo"
                        style={{ height: "2.5rem", marginBottom: "15px" }}
                      />
                      <ErrorMessage
                        name="accountNo"
                        component="div"
                        className="error-message red-text marginTop--15px mb-1"
                        style={{ marginBottom: "15px", fontSize: "12px" }}
                      />
                    </span>
                    <span>
                      <label className="font-16px black-text">
                        Re-Enter Account Number
                        <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style"
                        type="number"
                        id="no-paste"
                        name="re_accountNo"
                        style={{ height: "2.5rem", marginBottom: "15px" }}
                      />
                      <ErrorMessage
                        name="re_accountNo"
                        component="div"
                        className="error-message red-text marginTop--15px mb-1"
                        style={{ marginBottom: "15px", fontSize: "12px" }}
                      />
                    </span>
                    <span>
                      <label className="font-16px black-text">
                        IFSC code <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style"
                        type="text"
                        name="ifsc"
                        style={{ height: "2.5rem", marginBottom: "15px" }}
                      />
                      <ErrorMessage
                        name="ifsc"
                        component="div"
                        className="error-message red-text marginTop--15px mb-1"
                        style={{ marginBottom: "15px", fontSize: "12px" }}
                      />
                    </span>
                    <span>
                      <label className="font-16px black-text">
                        Bank Name <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style"
                        type="text"
                        name="bankName"
                        style={{ height: "2.5rem", marginBottom: "15px" }}
                      />
                      <ErrorMessage
                        name="bankName"
                        component="div"
                        className="error-message red-text marginTop--15px mb-1"
                        style={{ marginBottom: "15px", fontSize: "12px" }}
                      />
                    </span>
                    <span>
                      <label className="font-16px black-text">
                        Branch <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style"
                        type="text"
                        name="branch"
                        style={{ height: "2.5rem", marginBottom: "15px" }}
                      />
                      <ErrorMessage
                        name="branch"
                        component="div"
                        className="error-message red-text marginTop--15px mb-1"
                        style={{ marginBottom: "15px", fontSize: "12px" }}
                      />
                    </span>
                    <span>
                      <label className="font-16px black-text">
                        Account Holders Name <span className="red-text">*</span>
                      </label>
                      <Field
                        className="input-tag-style"
                        type="text"
                        name="holderName"
                        style={{ height: "2.5rem", marginBottom: "15px" }}
                      />
                      <ErrorMessage
                        name="holderName"
                        component="div"
                        className="error-message red-text marginTop--15px mb-1"
                        style={{ marginBottom: "15px", fontSize: "12px" }}
                      />
                    </span>
                    <span>
                      <label className="font-16px black-text">
                        Cheque File <span className="red-text">*</span>
                      </label>
                      <div className="pin-top">
                        <input
                          type="text"
                          readOnly
                          className="input-tag-style pointer"
                          style={{ height: "2.5rem" }}
                          onClick={handleSpanClick}
                          value={fileName}
                        />
                        <input
                          type="file"
                          id="file-input"
                          name="chequeFile"
                          accept=".jpg, .jpeg, .pdf"
                          onChange={(event) =>
                            handleFileChange(event, setFieldValue)
                          }
                          style={{ display: "none" }} // Hide the default file input
                          ref={fileInputRef} // Reference to the input element
                        />
                        <span
                          className="material-icons-outlined cercle-purple-text"
                          style={{
                            position: "absolute",
                            top: "10%",
                            right: "0%",
                            fontSize: "25px",
                          }}
                        >
                          cloud_upload
                        </span>
                        {errors.chequeFile && touched.chequeFile && (
                          <div
                            className="error-message red-text"
                            style={{ fontSize: "12px", marginTop: "1px" }}
                          >
                            {errors.chequeFile}
                          </div>
                        )}
                        {fileName === "" && (
                          <p
                            className="mb-1 red-text text-lighten-1"
                            style={{ fontSize: "12px" }}
                          >
                            The supported file formats include JPG, JPEG, and
                            PDF.
                          </p>
                        )}
                      </div>
                    </span>
                  </div>

                  <button
                    className="button-style white-text cercle-purple pointer mt-1"
                    style={{ padding: "12px 45px" }}
                  >
                    Submit
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default WalletUpdateBank;
